import { Select, SelectProps } from "@stenajs-webui/select";
import React, { useMemo } from "react";
import { SailingCategoryOption } from "./PriceCalculatorTimeTableSelect";

interface Props
  extends Omit<SelectProps<any>, "value" | "onChange" | "disabled"> {
  value?: string;
  onValueChange?: (value: SailingCategoryOption) => void;
  disabled?: boolean;
  manualDeparture: boolean;
}

const sailingCategories = [
  {
    label: "Peak",
    value: "P",
    type: "sailingCategory",
  },
  {
    label: "Shoulder",
    value: "S",
    type: "sailingCategory",
  },
  {
    label: "Off-Peak",
    value: "O",
    type: "sailingCategory",
  },
];

export const PriceCalculatorDepartureCategorySelect: React.FC<Props> = ({
  onValueChange,
  value,
  disabled,
  manualDeparture,
  ...selectProps
}) => {
  const selected = useMemo(
    () => sailingCategories.find((o) => value === o.value),
    [value]
  );
  return (
    <Select
      {...selectProps}
      value={manualDeparture ? selected : null}
      options={sailingCategories}
      onChange={(sailingCategory) => {
        if (sailingCategory) {
          onValueChange?.(sailingCategory as SailingCategoryOption);
        }
      }}
      isDisabled={disabled}
      menuPortalTarget={document.body}
    />
  );
};
